/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DxNumberBoxModule, DxButtonModule } from 'devextreme-angular';
import { SysqueNumberBoxOptionsLineComponent } from './sysque-number-box-options-line.component';

@NgModule({
  declarations: [SysqueNumberBoxOptionsLineComponent],
  imports: [CommonModule, FormsModule, DxNumberBoxModule, DxButtonModule],
  exports: [SysqueNumberBoxOptionsLineComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SysqueNumberBoxOptionsLineModule {}
